import { Component, input } from '@angular/core';

export interface ListPageColumn {
  key: string;
  label: string;
  width?: string;
}

@Component({
  selector: 'app-list-placeholder',
  templateUrl: './list-placeholder.html',
  styleUrl: './list-placeholder.scss',
})
export class ListPlaceholder {
  readonly columns = input.required<ListPageColumn[]>();
  readonly emptyTitle = input('No records yet');
  readonly emptyMessage = input('Data will appear here once this module is connected to the API.');
  readonly rowCount = input(5);
}
